import { Button, Checkbox, Col, Form, Row } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import iconEditActive from '../../../../assets/icons/icon-edit-active.svg';
import iconEdit from '../../../../assets/icons/icon-edit.svg';
import FormCustom from '../../../../components/FormCustom';
import { sortFieldsByPriority } from '../../utils.js';

const SettingPerNamespace = ({
  form,
  service,
  onFinishPerNamespace,
  initialPerNameSpace,
  checkUpdatePerNamespace,
  setCheckUpdatePerNamespace,
  dataPerNameTemp,
  listNotificationService,
  dataSelectNotificationEvent,
  onChangeEventNotification,
}) => {
  const { t } = useTranslation();

  const parsedConfig = React.useMemo(() => {
    if (!service?.configurationInput) return null;
    try {
      return JSON.parse(service.configurationInput);
    } catch {
      return null;
    }
  }, [service?.configurationInput]);

  const hasPerNamespace = parsedConfig?.perNamespace?.length > 0;
  const hasPerAccount = parsedConfig?.perAccount?.length > 0;

  if (!hasPerNamespace) return null;

  const isFullWidth = hasPerNamespace && hasPerAccount;
  const spanLayout = isFullWidth ? 8 : 24;

  const notificationField = parsedConfig?.perNamespace?.find(
    (item) => item.field === 'notificationEvent'
  );

  return (
    <Col
      className="step-1-col"
      span={isFullWidth ? 24 : 8}
      style={{
        marginBottom: isFullWidth ? '8px' : '0px',
      }}
    >
      <Form
        form={form}
        style={{ paddingTop: '16px' }}
        name="register-service"
        layout="vertical"
        onFinish={onFinishPerNamespace}
        initialValues={service?.configuration ?? initialPerNameSpace ?? {}}
      >
        <Row style={{ width: '100%' }}>
          {sortFieldsByPriority(parsedConfig?.perNamespace).map(
            (item, index) => (
              <FormCustom
                key={index}
                spanLayout={spanLayout}
                data={item}
                dataSerial={service}
                disabled={checkUpdatePerNamespace}
              />
            )
          )}
          {!!listNotificationService?.eventInfos?.length && notificationField && (
            <Col span={24}>
              <Form.Item
                style={{ width: '100%' }}
                label={notificationField?.fieldDisplay ?? t('Event notification')}
              >
                {listNotificationService?.eventInfos?.map((item) => (
                  <Checkbox
                    key={item.eventKey}
                    checked={!!dataSelectNotificationEvent?.[item.eventKey]}
                    onChange={(value) => onChangeEventNotification(value, item)}
                    style={{ marginLeft: '8px' }}
                    disabled={checkUpdatePerNamespace}
                  >
                    {item.message}
                  </Checkbox>
                ))}
              </Form.Item>
            </Col>
          )}
          <Col span={24}>
            <Form.Item style={{ width: '100%', textAlign: 'center' }}>
              <Button
                disabled={checkUpdatePerNamespace}
                type="primary"
                htmlType="submit"
              >
                {t('Update')}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <img
        onClick={() => {
          setCheckUpdatePerNamespace(checkUpdatePerNamespace ? false : true);
          if (!checkUpdatePerNamespace) {
            form.setFieldsValue(dataPerNameTemp);
          }
        }}
        style={{
          position: 'absolute',
          top: '16px',
          right: '16px',
          cursor: 'pointer',
        }}
        src={checkUpdatePerNamespace ? iconEdit : iconEditActive}
        alt="next-page"
      />
    </Col>
  );
};

export default SettingPerNamespace;
